<template>
  <div class="container">
    <github-button
      class="button"
      href="https://github.com/error-guru/error-guru.github.io/subscription"
      data-icon="octicon-eye"
      data-size="large"
      data-show-count="true"
      aria-label="Watch error-guru/error-guru.github.io on GitHub"
    >Watch</github-button>
    <github-button
      class="button"
      href="https://github.com/netaneld122"
      data-size="large"
      data-show-count="true"
      aria-label="Follow @netaneld122 on GitHub"
    >Follow</github-button>
    <github-button
      class="button"
      href="https://github.com/error-guru/error-guru.github.io/issues"
      data-icon="octicon-issue-opened"
      data-size="large"
      data-show-count="true"
      aria-label="Issue error-guru/error-guru.github.io on GitHub"
    >Issue</github-button>
  </div>
</template>

<script scoped>
import GithubButton from "vue-github-button";

export default {
  name: "GithubButtons",
  components: {
    GithubButton
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 3px;
  text-align: center;
}

.button {
  margin: 3px;
  opacity: 0.8;
}
.button:hover {
  margin: 3px;
  opacity: 1;
}
</style>